import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  TableContainer,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { BsFillPencilFill, BsSearch } from 'react-icons/bs';
import { Link, useParams } from 'react-router-dom';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import DebounceInput from '../../Components/DebounceInput';

export const FormSubmissionsLoader = () => async () => ({
  name: 'Submissions',
});

const FormSubmissionsPage = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const [search, setSearch] = useState('');
  const { formId } = useParams();

  return (
    <Flex direction="column">
      <Card
        my="22px"
        overflowX={{ sm: 'scroll', xl: 'hidden' }}
        pb="0px"
      >
        <CardHeader>
          <Flex direction="row" justify="space-between">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Submissions
            </Text>
            <Button
              as={Link}
              to={`/form/${formId}/edit`}
              leftIcon={<Icon as={BsFillPencilFill} />}
              colorScheme="blue"
              variant="outline"
              size="sm"
            >
              Edit
            </Button>
          </Flex>
        </CardHeader>
        <CardBody pt="0">
          <Flex width={{ md: '50%' }}>
            <InputGroup mb="4" mr="4">
              <InputLeftElement pointerEvents="none">
                <BsSearch />
              </InputLeftElement>
              <DebounceInput as={Input} onChange={setSearch} />
            </InputGroup>
          </Flex>
          <TableContainer>
            <Table color={textColor} size="sm">
              <TableHeader />
              <TableBody search={search} />
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default FormSubmissionsPage;
